import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useContext } from 'react';
import { InvoiceDetailsContext, InvoiceDetailsValues } from '../contexts/InvoicesContext';
import { CloseDialogAction } from '../../../components/shared/dialogs/CloseDialogAction';

export const EditNoteModal = () => {
  const { closeEditNoteModal, note, openEditNoteModal, updateItemNote, itemId } = useContext(InvoiceDetailsContext) as InvoiceDetailsValues;

  const handleClose = () => {
    closeEditNoteModal();
  };

  return (
    <Dialog onClose={handleClose}
      open={openEditNoteModal}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>
        Edit Note
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <TextField fullWidth
          multiline
          minRows={4}
          onChange={updateItemNote(itemId)}
          value={note}>
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button variant='secondary'
          fullWidth
          size="lg"
          onClick={handleClose}>
          {('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
